import React from "react";
import PersonalizedBeautyImg from "./PersonalizedBeautyImg";
import PersonalizedBeautyHead from "./PersonalizedBeautyHead";
import HairServImg from "../../HairBotox/HairServImg";
import PersonalizedBeautyTips from "./PersonalizedBeautyTips";
import PersonalizedBeautyFinal from "./PersonalizedBeautyFinal";
import BlogSideBar from "../../../BlogSideBar/BlogSideBar";
import PersonalizedFinal from "./../../../../../Images/Blog/how-modern-salons-are-customizing-hair/Final Thoughts.png";
import tenHairColorTips from "./../../../../../Images/Blog/how-modern-salons-are-customizing-hair/image-hair.png";
import { Helmet } from "react-helmet";

const PersonalizedBeauty = () => {
  return (
    <div>
      <Helmet>
        <meta charSet="UTF-8" />
        <title>Personalized Beauty: How Modern Salons Are Customizing Hair & Skin Treatments</title>
        <meta
          name="description"
          content="Discover how personalized beauty is transforming salon experiences. Learn how Scent Lifestyle, one of the best hair salons in Bangalore, offers customized hair and skin treatments tailored to your needs. "
        />
        <link
          rel="canonical"
          href="https://scentlifestyle.com/How-Modern-Salons-Are-Customizing-Hair-and-Skin-Treatments"
        />
      </Helmet>
      <div className="blog-container">
        <div className="blog-wrapper1">
          <PersonalizedBeautyImg />
          <PersonalizedBeautyHead />
          <br />
          <HairServImg hairBotoxImg={PersonalizedFinal} />
          <PersonalizedBeautyTips />
          <br />
          <HairServImg hairBotoxImg={tenHairColorTips} />
          <PersonalizedBeautyFinal />
        </div>
        <div className="blog-wrapper2">
          <BlogSideBar />
        </div>
      </div>
    </div>
  );
};

export default PersonalizedBeauty;


